import { Image } from 'react-native'

const CacheableImage = Image

export { CacheableImage }
